import * as ReactDOM from 'react-dom/client';
import { Layout } from './layout.tsx';
import { StrictMode } from 'react';
import { Toaster } from 'react-hot-toast';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from 'react-router-dom';
import { HomeView } from './view/home-view.tsx';
import { HomeRoute } from './view/route/home-route.tsx';
import { PreviewJobRoute } from './view/route/preview-job-route.tsx';
import { PaymentRoute } from './view/route/payment-route.tsx';
import { ProcessingRoute } from './view/route/processing-route.tsx';
import { InvalidJobRoute } from './view/route/invalid-job-route.tsx';
import { PrivacyPolicyRoute } from './view/route/privacy-policy-route.tsx';
import { TermsRoute } from './view/route/terms-route.tsx';
import { RefundPolicyRoute } from './view/route/refund-policy-route.tsx';
import { SupportRoute } from './view/route/support-route.tsx';
import { BugReportsFeaturesRoute } from './view/route/bug-reports-features-route.tsx';
import { BackgroundPattern } from './components/pattern/background-pattern.tsx';

import './index.css';
import './locale/localization.ts';

const rootElement = document.getElementById('root') as HTMLElement;
const reactRoot = ReactDOM.createRoot(rootElement);

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<Layout />}>
            <Route element={<HomeView />} errorElement={<Navigate to="/" replace />}>
                <Route index element={<HomeRoute />} />
                <Route path="preview/:jobId" element={<PreviewJobRoute />} />
                <Route path="payment/:jobId" element={<PaymentRoute />} />
                <Route path="payment/:jobId/cancelled" element={<PaymentRoute showCheckoutCancelledNotice />} />
                <Route path="processing" element={<ProcessingRoute />} />
                <Route path="invalid-job" element={<InvalidJobRoute />} />
            </Route>
            <Route path="privacy-policy" element={<PrivacyPolicyRoute />} />
            <Route path="terms" element={<TermsRoute />} />
            <Route path="refunds" element={<RefundPolicyRoute />} />
            <Route path="support" element={<SupportRoute />} />
            <Route path="bug-reports-features" element={<BugReportsFeaturesRoute />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
    )
);

reactRoot.render(
    <StrictMode>
        <Toaster />
        <BackgroundPattern />
        <RouterProvider router={router} />
    </StrictMode>
);
